/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadResolvePanel/PeoplePickerWrapper" />
import React = require("react");
import AdminResources = require("TFS/Admin/OrganizationAadControls/Resources");
import { ObservableValue } from "VSS/Core/Observable";
import { IdentityPickerDropdown, IIdentity } from "VSSUI/IdentityPicker";
import { VssComponent } from "VSS/Platform/Layout";
import { IPeoplePickerWrapperComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/ComponentControls.props";

export class PeoplePickerWrapperComponent extends React.Component<IPeoplePickerWrapperComponentProps> {
    private identity: ObservableValue<IIdentity | undefined> = new ObservableValue<IIdentity | undefined>(undefined);

    public render(): JSX.Element {
        return (
            <IdentityPickerDropdown
                className={this.props.isAadGuestUser ? "resolve-panel-people-picker-grey" : ""}
                pickerProvider={this.props.pickerProvider}
                onChange={this._onPersonChange}
                calloutWidth={290}
                placeholder={AdminResources.SearchDirectory}
                onClear={this._onClearSearchBox}
                value={this.identity}
            />
        );
    }

    private _onPersonChange = (item?: IIdentity): void => {
        this.props.onUpdateMappingIdentity(this.props.index, item);
        this.identity.value = item;
    };

    private _onClearSearchBox = (): void => {
        this.props.onClearSearchBox(this.props.index);
    };
}

VssComponent.register("ms.vss-admin-web.aad-people-picker-wrapper", PeoplePickerWrapperComponent);
